import React from "react";
import SelectDropdown from "./shared/SelectDropdown";

const DATA_VIEW_OPTIONS = Object.freeze({
  all: { label: "All Rows" },
  errors: { label: "Alert Rows" },
  selected: { label: "Selected Rows" },
  unselected: { label: "Unselected Rows" },
});

const SubmissionDataViewSelector = ({ selectedDataView, setSelectedDataView, visibleOptions }) => {
  const keys = visibleOptions ?? Object.keys(DATA_VIEW_OPTIONS);
  const options = keys.map((key) => ({ value: key, ...DATA_VIEW_OPTIONS[key] }));

  return (
    <SelectDropdown options={options} value={selectedDataView} onChange={setSelectedDataView} />
  );
};

export default SubmissionDataViewSelector;
